<template>
  <div class="wrapper">
    <!-- <div class="bronze text-capitalize f10 font-weight-bold mb-2">

      {{ user.tier ? user.tier.name.split(' ')[0] : 'bronze' }} Member
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div> -->

    <!-- :class="{
        'bronze': user.tier === 'bronze',
        'gold': user.tier === 'gold',
        'silver': user.tier === 'silver',
        'platinum': user.tier === 'platinum'
      }" -->
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$store.state.profile.data
    }
  }
}
</script>
